import { MembersApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const membersApi = MembersApi({}, '/api', axiosInstance);
